<template>
<div>
  <div style="overflow: auto; height: 100%" ref="fadeWhenModelOpen">
    <div style="height:50px;" class="comm-settings-top-nav">
      <div class="col-md-12 justify-content-start p-0 h-100">
        <nav aria-label="breadcrumb" class="h-100">
          <ol class="breadcrumb comm-settings-top-nav m-0 h-100">
            <li class="comm-icon-rtl"><back-button  v-on:click.native="handleBackNavigation()" style="position: relative;"></back-button></li>
            <!-- <li class="breadcrumb-item active-text-nav-bar" aria-current="page">{{selectedCustomKeyName}}</li> -->
            </ol>
        </nav>
      </div>
    </div>
    <div class="set-height-of-div">
    <table class="table users-basic-info-table" style="background: transparent">
      <thead style="color: #eee">
        <tr>
          <th scope="col" style="width: 20%"></th>
          <th scope="col" style="width: 80%"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="key-div">{{$t('Name')}} *</td>
          <td class="value-div d-flex m-0">
            <div style="display:inline-grid">
            <input type="text" id="name" class="rounded text-light comm-input-field-style"
             style="width:331px;" autocomplete="off" placeholder="Enter field name"
              v-model="keyInfo.name"
            />
            <div v-if="'language_alias_mapper' in keyInfo && keyInfo.language_alias_mapper && keyInfo['language_alias_mapper'].length > 0" class="main-wrapper" style="display: inline-flex; padding-top: 10px; color: rgb(163, 163, 163); flex-wrap: wrap;">
              <div v-for="(eachLang,index) in keyInfo.language_alias_mapper" :key="eachLang._id" class="each-lang" style="display: inline-flex; margin-inline-end: 3px; margin-bottom: 8px;">
                <span class="key-div">{{ 'In ' + eachLang.name + ' :' }}</span>
                <div class="ellipsis-to-entry">{{ eachLang.field_alias }}</div>
                <span v-if="index < (keyInfo.language_alias_mapper.length - 1)" style="padding-inline-start: 1px;">, </span>
              </div>
            </div>
            <button class="add-to-lang-dict-styles" @click="addLangDict()">
              {{$t('Add to Language Mapper')}}
            </button>
            </div>
          </td>
        </tr>
        <tr>
          <td class="key-div">{{$t('Type')}} *</td>
          <td class="value-div d-flex m-0">
            <Multiselect 
              :value="searchFilters.label"
              :options="fieldTypes"
              :searchable="false"
              :close-on-select="true"
              :allow-empty="false"
              @select="filterByType($event)"
              :label="label"
              deselectLabel=""
              selectLabel=""
              selectedLabel=""
              placeholder="Select Field Type"
              :track-by="type">
              <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
              <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
              </div>
            </Multiselect>
          </td>
        </tr>
        <template v-if="['PICKLIST_MULTIVALUE','PICKLIST'].includes(keyInfo.type)">
          <tr>
            <td class="key-div p-2 align-middle" style="width:20%">{{$t('Values')}} *</td>
            <td class="value-div d-flex m-0 p-2" style="width:38%;">
              <div style="    display: flex;">
                <div class="col-md-12 rounded p-0" id="values" style="height:auto">
                  <ul class="p-0 m-0 active-tag lists-display-ul" :class="{applyBorderOnScroll:multiValueList.length>5}">
                    <li @click="checkNewValueVisibility()" class='add-new-lists-styles'>
                      <div style="margin-inline-end: 5px;position: relative;top: -2px;">
                          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="25" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                            <path d="M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z"/>
                          </svg>
                        </div>
                        <div style="font-size: 14px;">{{$t('Add picklist values')}}</div>
                    </li>
                    <template v-for="(value, index) in multiValueList">
                      <li id="tag_field" v-if="value.trim().length" class='view-lists' :key="index">
                        <div class="w-100">
                          <div class="d-inline-flex">
                            <span v-show="!isEditting(index)">{{value}}</span>
                            <edit-icon @click.native="editValueNameField(index, value)"
                              v-show="!isEditting(index)" class="edit-value-icon show-tags-delete">
                            </edit-icon>
                            <div class="show-tags-delete" v-show="!isEditting(index)" 
                              @click="removeValueFromList(index, value)" >
                              <svg width="16" height="16" viewBox="0 0 16 16" class="bi bi-trash-fill" style="margin-inline-end: 8px" fill="#c5c0c0" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7z"/>
                              </svg>
                            </div>
                          </div>
                          <input
                          minlength="3"
                          type="text"
                          v-model="editedValue"
                          v-show="isEditting(index)"
                          :ref="index"
                          class="rounded text-light comm-input-field-style align-input-field"
                          style="padding-inline-start: 7.4px;"
                          required
                          />
                        </div>
                        <div v-show="isEditting(index)">
                          <div class="d-flex">
                            <save-icon @click.native="updateSeletedValue(index)"></save-icon>
                            <cancel-icon @click.native="selectedValueIndex = -1"></cancel-icon>
                          </div>
                        </div>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
            </td>
          </tr>
        </template>
        <tr>
          <td class="key-div p-2 align-middle" style="width:20%">{{$t(' Child Field')}}</td>
          <td class="value-div d-inline-block m-0 p-2" style="width:80%;float:inline-start">
            <!-- <div class="d-inline-flex w-25 pb-2">
              <input type="radio"  value="root" v-model="typeOfField" @change="typeOfField='root'" class="bg-transparent border rounded text-light bigger-checkboxes" name="type of field"/>
              <label style="position: relative;bottom: 1px;inset-inline-start:5px">{{$t('Root')}}</label>
            </div>
            <div style="display:grid">
              <div class="d-inline-flex w-25">
                <input type="radio"  value="parent" v-model="typeOfField"  @change="typeOfField='parent'" class="bg-transparent border rounded text-light bigger-checkboxes" name="type of field"/>
                <label style="position: relative;bottom: 1px;inset-inline-start:5px">{{$t('Parent')}}</label>
              </div>
            </div> -->
            <div class="custom-control custom-switch">
              <input
                v-on:click="isChildField"
                type="checkbox"
                class="custom-control-input"
                id="childField"
                :checked='isChildField'
                @change="changeChildType"
              />
              <label class="custom-control-label" for="childField"></label> 
            </div>
            <label class="key-div" style="text-align: start;margin-bottom:0px !important">{{ $t('On enabling Child Field, a field will be added as a child field for the selected parent field') }}.</label>
          </td>    
        </tr>
        <tr v-if="isChildField">
          <td class="key-div p-2 align-middle" style="width:20%">{{$t('Parent Field')}} *</td>
          <td class="value-div d-inline-block m-0 p-2 parent-fields-wrapper" style="width:80%;float:inline-start">
            <Multiselect
                id="fieldNameField"
                class="parent-field-dropdown"
                v-model="parentField" 
                :options="parentFieldOptions"
                label="name"
                track-by="_id"
                :close-on-select="true"
                :multiple=false
                :show-no-results="true"
                deselectLabel =""
                selectLabel=""
                selectedLabel=""
                :placeholder="$t('Enter field name')"
                :hideSelected="false"
                :showNoOptions="false"
                @open="getFieldsFromServer"
                @search-change="getusersOnKeyup($event)"
                @select="userTypeOnSelect($event)"
                >
                <span slot="noResult">No results.</span>
            </Multiselect>
            <div v-if="Object.keys(valueOfSelectedParentField).length>0" style="margin:10px 0px 4px 0px;display:inline-flex;width:100%;">
              <span class="key-div"> {{$t('Value is')}} : </span>
              <span style="white-space: pre-wrap;padding-inline-start: 5px;">{{ showParentFieldValue() }}</span>
            </div>
            <div v-if="isParentFieldChanged" style="color: #fd5c5c;font-size: 13px;">
              <span style="color:red;padding-inline-start:3px !important">{{ $t('Given Value is mismatching with selected Parent Field') }}</span>
            </div>
            <div>
              <button class="add-to-lang-dict-styles" @click="addExpressionvalue()">
                {{$t('Add value to Parent field')}}
              </button>
              <span @click="resetParentValue()" style="    padding-inline-start: 0px !important;position: relative;bottom: 3px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
                  <title>Reset</title>
                </svg>
              </span>
            </div>  
          </td>    
        </tr>
        <tr>
          <td class="key-div">{{$t('System Defined')}}</td>
          <td class="value-div d-inline-block m-0" style="width:100%;">
            <!-- <Multiselect
              :value="definationFilter.label"
              :options="definationTypes"
              :searchable="false"
              :close-on-select="true"
              :allow-empty="false"
              @select="filterByDefType($event)"
              :label="label"
              deselectLabel=""
              selectLabel=""
              selectedLabel=""
              placeholder="Select Defination Type"
              :track-by="type">
              <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
              <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
              </div>
            </Multiselect> -->
            <div class="custom-control custom-switch">
              <input
                v-on:click="isSystemDefinedField"
                type="checkbox"
                class="custom-control-input"
                id="systemDefined"
                :checked='isSystemDefinedField'
                @change="changeSystemDefinedType"
              />
              <label class="custom-control-label" for="systemDefined"></label>
            </div>
            <label class="key-div" style="text-align: start;margin-bottom:0px !important">{{ $t('On making field as system-defined, system will generates the value for this field and it cannot be changed by user') }}.</label>
          </td>
        </tr>
        <tr style="#bbb">
          <td class="key-div p-2 align-middle" style="width:20%">{{$t('Semantic Field Category')}}</td>
          <td class="value-div d-inline-block m-0 p-2" style="width: 80%; float: inline-start;">
            <Multiselect 
              :value="selectedFieldCategory"
              :options="fieldCategories"
              :searchable="false"
              :close-on-select="true"
              :allow-empty="false"
              @select="handleFieldCategoryChange($event)"
              label="label"
              deselectLabel=""
              selectLabel=""
              selectedLabel=""
              :placeholder="$t('Select Category')"
              track-by="id">
              <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                <span style="margin-left:12px;">{{ scope.option.label }}</span>
              </div>
            </Multiselect>
            <label class="key-div" style="text-align: start;">{{$t('Select a category to help Semantic Search understand the type of information stored in this field and match user queries more accurately')}}.</label>
          </td>
        </tr>
       
        <tr style="#bbb">
          <td class="key-div p-2 align-middle" style="width:20%">{{$t('Short Key')}}</td>
          <td class="value-div d-flex m-0 p-2" style="width:80%;">
            <div style="display: inline-grid;">
              <input type="text" id="name" class="rounded text-light comm-input-field-style"
              style="width:331px;" autocomplete="off"
                v-model="keyInfo.short_key" placeholder="Enter short key"
              />
              <label class="key-div" style="text-align: start;">{{$t('Short key mentioned on file name for extraction')}}.</label>
            </div>
          </td>
        </tr>
        <tr style="#bbb">
          <td class="key-div p-2 align-middle" style="width:20%">{{$t('About Field')}}</td>
          <td class="value-div d-flex m-0 p-2" style="width:80%;">
            <div style="display: inline-grid;">
               <input type="text" id="name" class="rounded text-light comm-input-field-style"
              style="width:331px;" autocomplete="off"
                v-model="keyInfo.about_field"
                placeholder="Enter about field"
              />
               <label class="key-div" style="text-align: start;">{{$t('Short description about the field')}}.</label>
            </div>
          </td>
        </tr>
        <tr style="#bbb" v-if="isPrivEnabled('manage-screens') && !isChildField">
          <td class="key-div p-2 align-middle" style="width:20%">{{$t('Add field to')}}</td>
          <td class="value-div d-inline-block m-0 p-2" style="width:80%;float:inline-start">
            <div class="d-inline-flex w-25 pb-2">
              <input type="radio"  value="allFields" v-model="setFieldType" @change="isCustomisedFields=false,setFieldType=allFields" class="bg-transparent border rounded text-light bigger-checkboxes" name="file type"/>
              <label style="position: relative;bottom: 1px;inset-inline-start:5px">{{$t('All screens')}}</label>
            </div>
            <div style="display:grid">
              <div class="d-inline-flex w-25">
                <input type="radio"  value="customisedFields" v-model="setFieldType"  @change="isCustomisedFields=true,setFieldType=customisedFields" class="bg-transparent border rounded text-light bigger-checkboxes" name="file type"/>
                <label style="position: relative;bottom: 1px;inset-inline-start:5px">{{$t('Customize screens')}}</label>
              </div>
              <div style="display: inline-flex;" v-if="isCustomisedFields">
                <div style="flex-wrap: wrap;justify-content: start;display: inline-flex;padding:14px;float:inline-start">
                  <div v-on:click="enableScreenBrowserClick()"><div class="add-user-icon-wrapper"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                            <path d="M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z"/>
                          </svg></div>
                    <div>{{$t('Add screen')}}</div>
                    </div>
                    <div v-for="screenId in selectedScreenIdList" :key="screenId" class="comm-tags-class" style="width:100px;margin-bottom: 8px;position:relative;margin: 0px 3px;">
                      <div class="icons-with-text-wrapper">
                      <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="#757575" class="bi bi-layout-text-sidebar-reverse" viewBox="0 0 16 16">
                          <path d="M12.5 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5zm0 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5zm.5 3.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5zm-.5 2.5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5z"/>
                          <path d="M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2zM4 1v14H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h2zm1 0h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5V1z"/>
                        </svg>
                        </div>
                      <div style="text-align:center">{{getScreenIdName(screenId)}}</div>
                      <cancel-icon class="delete-user-icon" @click.native="toggleSelectedScreensInList(screenId)"></cancel-icon>
                    </div>
                </div> 
            </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="primary-btn-style">
      <button @click="createNewKey()" class="btn btn-outline-primary mr-3" data-v-198e7d7f="">
        {{$t('Save')}}
      </button>
      <button class="btn btn-outline-secondary mr-3" data-dismiss="modal"  v-on:click="changeToSelectedCustomMetadataTableComponent('show-custom-metadatas')">{{$t('Cancel')}}</button>
    </div>
    </div>
    </div>
    <add-multi-value v-show="isNewValModelVisible" @close="handleSubMultiValueClose">
    </add-multi-value>
    <browse-screens v-if="enableScreenBrowser" @close="closeScreenBrowser" :selectedScreenFieldIds="selectedScreenIdList"></browse-screens>
    <LanguageMapper v-if="enableLanguageMapperDialog" :profileName="keyInfo.name" :selectedFieldResp="keyInfo" @close="enableLanguageMapperDialog=false" @updateLangMapper="handleLangMapperChanges" :newField="true"></LanguageMapper>
    <FieldExpression v-if="enableExpressionValueDialog" 
      :selectedParentField="parentField" 
      @closeFeildExpressionModel="enableExpressionValueDialog=false" 
      :parentFieldOptionsList="parentFieldOptions" 
      :isExpressionEditContext="isExpressionEditContext" 
      :newField="true" 
      @addedExpressionDict="addParentFieldExpression"
      @selectedParentElement="selectedParentElementObj"
      :beforeAddedValues="valueOfSelectedParentField"></FieldExpression>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import {mapActions,mapGetters} from "vuex"
import Utils from "../../components.utils.js";
import AddMultiValue from "./AddMultiValue.vue"
import EditIcon from "../core/InlineEditField.vue";
import SaveIcon from "../core/InlineSaveField.vue";
import CancelIcon from "../core/InlineCancelField.vue";
import BackButton from "../core/backButton.vue";
import BrowseScreens from "../screens/BrowseScreens.vue";
import LanguageMapper from "./LanguageFieldValueMapper.vue";
import FieldExpression from "./ParentFieldExpressionMapper.vue";

export default {
  data() {
    return {
      enableLanguageMapperDialog:false,
      enableExpressionValueDialog:false,
      keyInfo: {
        type:"FREETEXT",
        definition_type:"user-defined",
        language_alias_mapper:[],
      },
      multiValueList:[],
      selectedScreenIdList:[],
      enableScreenBrowser:false,
      screensInfo:[],
      editedValue:"",
      selectedValueIndex:-1,
      isNewValModelVisible:false,
      selectedComponent: null,
      selectedPluginInfo:null,
      setFieldType:"allFields",
      isCustomisedFields:false,
      pluginsData: [],
      searchFilters:{
        type:'FREETEXT',
        label: 'Plaintext'
      },
      selectedFieldCategory:{
        label:'NONE',
        id:''
      },
      fieldCategories:[
        {label:"NONE",id:""},
        {label:"Person",id:"person"},
        {label:"Place",id:"place"},
        {label:"Date",id:"date"},
        {label:"Number",id:"number"},
        {label:"Technical",id:"technical"},
        {label:"Other",id:"other"}
      ],
      fieldTypes:[
      {label:"Plaintext",type:"FREETEXT"},
      {label:"Plaintext Multiline",type:"FREETEXT_MULTILINE"},
      {label:"Date",type:"DATE"},
      {label:"Date Time",type:"DATE_TIME"},
      {label:"Integer",type:"INTEGER"},
      {label:"Picklist",type:"PICKLIST"},
      {label:"Picklist Multivalue",type:"PICKLIST_MULTIVALUE"}
      ],
      definationFilter:{label:"User defined",type:"user-defined"},
      definationTypes:[
        {label:"User Defined",type:"user-defined"},
        {label:"System Defined",type:"system-defined"},
      ],
      isChildField:false,
      isSystemDefinedField:false,
      typeOfField:'root',
      parentField: [],
      parentFieldOptions: [],
      usersList:[],
      // selectedParentfield:{},
      selectedUserIdNameMap:{},
      isExpressionEditContext:false,
      valueOfSelectedParentField : {},
      isParentFieldChanged : false,

    };
  },
  computed:{
    ...mapGetters("users",["getLoggedInUserPrivilege"])
  },
  components:{
    "Multiselect":Multiselect,
    "add-multi-value": AddMultiValue,
    "edit-icon": EditIcon,
    "save-icon": SaveIcon,
    "cancel-icon": CancelIcon,
    "back-button":BackButton,
    "browse-screens":BrowseScreens,
    LanguageMapper,
    FieldExpression,
  },
  methods : {
    addLangDict(){
      if(!('name' in this.keyInfo) || !this.keyInfo.name || this.keyInfo.name.trim() <= 0){
        alert("Please add valid field name.")
        this.enableLanguageMapperDialog = false
        return
      }
      this.enableLanguageMapperDialog = true;
    },

    addExpressionvalue(){
      if(Object.keys(this.parentField).length == 0){
        alert("Please select Parent Field");
        return false;
      }
      if(this.parentField.type == "DATE" || this.parentField.type == "DATE_TIME"){
        alert("'Add Value to Parent Field' is not supported with 'DATE' type Field");
        return false;
      }
      
      this.enableExpressionValueDialog = true;
    },
    handleBackNavigation(){
      let exitPage = true;
      if(Object.keys(this.keyInfo).length > 1
        || (this.multiValueList != undefined & this.multiValueList.length >0)
        || this.keyInfo.type != "FREETEXT" || this.keyInfo.definition_type != 'user-defined'
        || (this.selectedScreenIdList != undefined && this.selectedScreenIdList.length > 0)){
        if(!confirm(
            `Unsaved data exists. \nYou will loose the edited data if exit from the page.`
          )){
          exitPage = false
        }
       }
       if(exitPage){
         this.changeToSelectedCustomMetadataTableComponent('show-custom-metadatas');
       }
    },
    checkNewValueVisibility(){
      this.isNewValModelVisible = true;
      this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
    },
    enableScreenBrowserClick(){
      this.enableScreenBrowser = true;
      this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
    },
    filterByType(fieldType){
      this.searchFilters = fieldType;
      this.keyInfo.type = fieldType.type;
      console.log("KeyInfo",fieldType);
    },
    filterByDefType(defType){
      this.definationFilter = defType;
      this.keyInfo.definition_type = defType.type;
    },
    handleFieldCategoryChange(fieldCategory){
      this.selectedFieldCategory = fieldCategory;
      this.keyInfo.field_category = fieldCategory.id;
    },
    closeScreenBrowser(screenIds){
      let i= 0;
      let screensList = [];
      if(screenIds.length > 0){
        while(i <screenIds.length){
          if(screensList.indexOf(screenIds[i]) < 0){
            screensList.push(screenIds[i]);
          }
          i++
        }
      }
      Object.assign(this.selectedScreenIdList, screensList);
      this.enableScreenBrowser = false;
      this.$refs.fadeWhenModelOpen.style.opacity = 1;
    },
    updateScreen(fieldId){
      if(typeof this.selectedScreenIdList == "undefined" || this.selectedScreenIdList.length <= 0){
        return;
      }
      for(let i=0;i<this.selectedScreenIdList.length; i++){
        let payload = {};
        if(typeof fieldId != "undefined"){
          let entryList = this.screensInfo.filter((screen)=>screen._id == this.selectedScreenIdList[i]);
          if(typeof entryList != "undefined" && entryList.length > 0){
            let fieldsIdList = entryList[0].field_id_list;
            fieldsIdList.push(fieldId);
            payload["field_id_list"] = fieldsIdList;
            payload._id = this.selectedScreenIdList[i];
            payload.params = { _id: this.selectedScreenIdList[i] };
            this.updateExistingScreens(payload).then((data) => {
              if (Utils.isAcceptedStatusCode(data.statusCode)){
                console.log(data.message);
              } else {
                this.$toast.error(data.message);
              }
            });
          }
        }
      }
    },
    updateSeletedValue(valueIndex){
      if(typeof this.editedValue == "undefined" || this.editedValue.trim().length <= 0){
        alert("Empty value is not supported.\nPlease enter valid value.")
        return;
      }
      if(this.multiValueList.includes(this.editedValue.trim())){
        alert("' " + this.editedValue.trim() + " ' value is already exists. Please add different value.")
        return;
      }
      this.multiValueList[valueIndex] = this.editedValue
      this.cancelSelectedValue()
    },
    cancelSelectedValue(){
      this.editedValue = ""
      this.selectedValueIndex = -1
    },
    handleSubMultiValueClose(valuesList = []){
      if(valuesList.length > 0){
        let i = 0;
        while(i < valuesList.length){
          if(!this.multiValueList.includes(valuesList[i].trim()) && valuesList[i].trim().length > 0){
            this.multiValueList.push(valuesList[i].trim())
          }
          i++
        }
      }
      this.isNewValModelVisible = false;
      this.$refs.fadeWhenModelOpen.style.opacity = 1;
    },
    setFocusToInputField(index){
      this.$nextTick(() => {
        const editIconRef = this.$refs[index];
        editIconRef[0].focus();
      });
    },
    editValueNameField(valueIndex, valueName) {
      this.editedValue = valueName;
      this.selectedValueIndex = valueIndex;
      this.setFocusToInputField(valueIndex)
    },
    isEditting(valueIndex) {
      return valueIndex === this.selectedValueIndex;
    },
    removeValueFromList(valueIndex){
      this.multiValueList.splice(valueIndex, 1);
    },
     changeToSelectedCustomMetadataTableComponent(compName, payload = {}){
            this.$emit("changeToSelectedCustomMetadataTableComponent", compName, payload)
    },
    toggleSelectedScreensInList(screenId){
      if(this.selectedScreenIdList.includes(screenId)){
        this.selectedScreenIdList.splice(this.selectedScreenIdList.indexOf(screenId),1);
      }
    },
    getScreenIdName(screenId){
      let screenDetails = this.screensInfo.filter((screen)=>screen._id == screenId);
      if(typeof screenDetails != "undefined" && screenDetails.length > 0){
        return screenDetails[0].name.trim();
      }
      return "";
    },

    addParentFieldExpression(data){
      this.valueOfSelectedParentField = data;
      if(Array.isArray(this.valueOfSelectedParentField)){
          if(this.valueOfSelectedParentField[0].PLabel != this.parentField.name){
              this.isParentFieldChanged = true;
          }else{
            this.isParentFieldChanged = false;
          }
        
      }else if(Object.keys(this.valueOfSelectedParentField).length >0){
        if(this.valueOfSelectedParentField.PLabel != this.parentField.name){
              this.isParentFieldChanged = true;
          }else{
            this.isParentFieldChanged = false;
          }
      }else if(this.valueOfSelectedParentField.type == 'FREETEXT' || this.valueOfSelectedParentField.type == 'INTEGER' || this.valueOfSelectedParentField.type == 'FREETEXT_MULTILINE'){
        if(this.valueOfSelectedParentField.PLabel != this.parentField.name){
          this.isParentFieldChanged = true;
        }else{
          this.isParentFieldChanged = false;
        }
      }
    },

    selectedParentElementObj(parentFieldObj){
      this.parentField = parentFieldObj;
    },

    showParentFieldValue(){
      let value ="";
      if(Array.isArray(this.valueOfSelectedParentField)){
        for(let i=0; i< this.valueOfSelectedParentField.length;i++){
          if(i==0){  
            value = this.valueOfSelectedParentField[i].label;
          }else{
            value = value + ", " +this.valueOfSelectedParentField[i].label; 
          }  
        }
      }else if(this.valueOfSelectedParentField.type == "FREETEXT" || this.valueOfSelectedParentField.type == 'FREETEXT_MULTILINE'){
        value = this.valueOfSelectedParentField.value;
      }else if(this.valueOfSelectedParentField.type == "PICKLIST"){
        value = this.valueOfSelectedParentField.label;
      }else if(this.valueOfSelectedParentField.type == "INTEGER"){
        value = this.valueOfSelectedParentField.value.from + " ~ " +this.valueOfSelectedParentField.value.to;
      }
      return value;
    },

    resetParentValue(){
      this.valueOfSelectedParentField = {};
      this.isParentFieldChanged = false;
    },

    createNewKey(){
      if(!Object.keys(this.keyInfo).includes('name') ||
        typeof this.keyInfo.name == "undefined" ||
        this.keyInfo.name.trim().length <= 0){
        alert("Please add name. ")
        document.getElementById("name").focus();
        return
      }
      if(['PICKLIST_MULTIVALUE','PICKLIST'].includes(this.keyInfo.type)){
        if(this.multiValueList.length <= 0){
          alert("Please add picklist value(s). ")
          document.getElementById("values").focus();
          return
        }
        let valInfo = []
        for(let val of this.multiValueList){
          valInfo.push({"value":val})
        }
        this.keyInfo.values = valInfo
      }
      if(!this.isChildField){
        if(this.isCustomisedFields){
          this.keyInfo["screen_id_list"] = this.selectedScreenIdList;
        }else{
          let idList = [];
          for(let s of this.screensInfo){
            if(!idList.includes(s._id)){
              idList.push(s._id);
            }
          }
          this.keyInfo["screen_id_list"] = idList;
          this.selectedScreenIdList = idList;
        }
      }  
      //if user-preffered lang is not English then add field name to the mapper
      if(this.$i18n && this.$i18n.locale && this.$i18n.locale != 'en'){
        let langIndx = this.keyInfo['language_alias_mapper'].findIndex(op=>op.code == this.$i18n.locale)
        if(langIndx >= 0){
          console.log(`Field with language ${this.$i18n.locale} Mapper added by users mannualy. Hence auto save is skipped`);
        }else{
          console.log(`Field with language ${this.$i18n.locale} Mapper not found in payload. Hence saving automatically.`);
          this.keyInfo['language_alias_mapper'].push({"field_alias": this.keyInfo.name.trim(),
                                                      "id": this.$i18n.locale,
                                                      "code": this.$i18n.locale,
                                                      "uuid": Utils.getUUID(),
                                                      "name": this.$i18n.locale_name})
        }
      }

      if(this.isChildField && this.parentField.length == 0){
        alert("No Parent Field selected");
        return false;
      }
      if(this.isParentFieldChanged){
        alert("The given value of parent field is mismatching with currently selected Parent field");
        return false;
      }
      if(this.parentField && Object.keys(this.parentField).length >0){
        let fieldIdsList = [];
        if(this.valueOfSelectedParentField){
          let parentFieldValueObj = null;
        
          if(this.parentField.type == 'FREETEXT' || this.parentField.type == 'INTEGER' || this.parentField.type == 'FREETEXT_MULTILINE'){
            parentFieldValueObj = this.valueOfSelectedParentField.value;
          }else if(this.parentField.type == 'PICKLIST_MULTIVALUE'){
            let selectedValueLIst = [];
            for(let i=0;i<this.valueOfSelectedParentField.length;i++){
              selectedValueLIst.push(this.valueOfSelectedParentField[i]._id)
            }
            parentFieldValueObj = selectedValueLIst;
          }else if(this.parentField.type == 'PICKLIST'){
            parentFieldValueObj = (Object.keys(this.valueOfSelectedParentField).length>0 && '_id' in this.valueOfSelectedParentField)?[this.valueOfSelectedParentField._id]:[];
          }  
            let parentFieldObj = {};
            parentFieldObj["id"] = this.parentField._id;
            parentFieldObj["type"] = this.parentField.type;
            parentFieldObj["value"] = parentFieldValueObj && parentFieldValueObj!= null?parentFieldValueObj:[];
            if(Object.keys(parentFieldObj).length>0){
              fieldIdsList.push(parentFieldObj);
            }  
        }
            
        this.keyInfo["load_when"] = fieldIdsList;
      }
      this.addNewCustomMetadata(this.keyInfo).then((data) => {
        if (Utils.isAcceptedStatusCode(data.statusCode)){
          this.$toast.success(data.message);
          let upsertedData = data.upserted_data;
          if(this.isPrivEnabled("manage-screens")){
            this.updateScreen(upsertedData._id);
          }
          this.$emit("changeToSelectedCustomKeyComponent", "show-custom-metadatas",{});
        } else {
          this.$toast.error(data.message);
        }
      });
    },
    handleLangMapperChanges(langList){
      if(langList){
        let langMappers = langList        
        this.keyInfo['language_alias_mapper'] = langMappers
      }else{
        this.keyInfo['language_alias_mapper'] = []
      }
      this.enableLanguageMapperDialog = false
    },
    refreshScreenInfo(){
      if(Object.keys(this.getStartUpDataFromInCache()).includes("screens")){
          this.screensInfo = this.getStartUpDataFromInCache()["screens"];
      }
      
      this.usersList = [];
      if(Object.keys(this.getStartUpDataFromInCache()).includes("custom_metadatas")){
          Object.assign(this.usersList,this.getStartUpDataFromInCache()["custom_metadatas"]);
      }
    },
    isPrivEnabled(privName){
      return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, privName)
    },
    changeChildType(){
      this.isChildField = !this.isChildField;
      if(this.isChildField == false){
        this.isParentFieldChanged = false;
      }
    },
    changeSystemDefinedType(){
      this.isSystemDefinedField = !this.isSystemDefinedField;
      if(this.isSystemDefinedField){
        this.keyInfo.definition_type = "system-defined";
      }else{
        this.keyInfo.definition_type = "user-defined";
      }  
    },

    getusersOnKeyup(option){
      if(typeof(option) != "undefined" && option.trim().length > 0){
        this.removeAlreadySelectedUsers(this.filteredUserGroups(option))
      }else if(option.length==0){
          this.removeAlreadySelectedUsers(this.usersList);
      }
    },

    filteredUserGroups(serachWord){
      if(serachWord){
        if (!this.usersList.length) {
          return [];
        }
        return this.usersList.filter((item) => {
          const userGroupName = item.name.toLowerCase();
          // const userGroupName = this.getCustomMetadataName(item).toLowerCase();
          const searchTerm = serachWord.toLowerCase();
          return userGroupName.includes(searchTerm);
        });
      }else{
          return this.usersList;
      }
    },

    removeAlreadySelectedUsers(usersList){
        let usersInGroup = usersList;
        if(this.selectedIds && this.selectedIds != undefined && this.selectedIds.length){
            for(let j = 0; j < this.selectedIds.length; j++){
                let temp = this.selectedIds[j];
                    usersInGroup =  usersInGroup.filter(function(el){
                    return el._id != temp;
                });
            }
            this.parentFieldOptions =  usersInGroup;
        }else{
            this.parentFieldOptions = usersInGroup;
        }
    },

    getCustomMetadataName(fieldInfo){
      if('language_alias_mapper' in fieldInfo && fieldInfo.language_alias_mapper && fieldInfo.language_alias_mapper.length > 0 && this.$i18n && this.$i18n.locale){
        let mapperExists = fieldInfo.language_alias_mapper.find(op=>op.code == this.$i18n.locale)
        if(mapperExists && Object.keys(mapperExists).length > 0 && mapperExists.field_alias && mapperExists.field_alias.length > 0){
          return mapperExists.field_alias;
        }
      }
      return fieldInfo.name;
    },

    getFieldsFromServer(){
      let payload = {}
      this.getAllCustomMetadataFromServer(payload).then((data)=>{
        let fieldList = [];
        fieldList = fieldList.concat(data.custom_metadatas)
        for(let eachField of fieldList){
          eachField['name'] = this.getCustomMetadataName(eachField)
        }
        this.parentFieldOptions = fieldList;
      });
    },

    // getDefaultFields(){
    //   if(this.screenType && this.screenType == "ScreenProfiles"){
    //     return [{"_id":"Description", "name":"Description"},
    //             {"_id":"Catalogs","name":"Catalogs"}]
    //   }
    //   return []
    // },

    userTypeOnSelect(option){
      if(Array.isArray(this.valueOfSelectedParentField)){
          if(this.valueOfSelectedParentField[0].PLabel != option.name){
              this.isParentFieldChanged = true;
          }else{
            this.isParentFieldChanged = false;
          }
        
      }else if(Object.keys(this.valueOfSelectedParentField).length >0){
        if(this.valueOfSelectedParentField.PLabel != option.name){
              this.isParentFieldChanged = true;
          }else{
            this.isParentFieldChanged = false;
          }
      }else if(this.valueOfSelectedParentField.type == 'FREETEXT' || this.valueOfSelectedParentField.type == 'INTEGER' || this.valueOfSelectedParentField.type == 'FREETEXT_MULTILINE'){
        if(this.valueOfSelectedParentField.PLabel != this.parentField.name){
          this.isParentFieldChanged = true;
        }else{
          this.isParentFieldChanged = false;
        }
      }

      if(option.type == "INTEGER"){
        this.parentField.value={
          'from':0,
          'to':1
        }
      }
    },
    // userTypeOnRemove(option){
    //   let index = this.parentFieldOptions.findIndex(item => item._id == option._id);
    //   if(index > -1){
    //       this.parentFieldOptions[index].checked = false; 
    //       this.parentField = this.parentField.filter(e => e._id != this.parentFieldOptions[index]._id);
    //   }
    // },
    
    // makeCheckBoxSelection(option){
    //   return this.parentField.some((op) => op._id === option._id);
    // },

    // removeSelectedOption(option){
    //   this.userTypeOnRemove(option)
    // },

    ...mapActions("customMetadata",["addNewCustomMetadata", "getAllCustomMetadataFromServer"]),
    ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
    ...mapActions("screens",["updateExistingScreens"])
  },
  created(){
    this.refreshScreenInfo();
  }
};
</script>


<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;

input[type="radio"] {
    outline: none !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: inline-block;
    padding: 4px;
    border-radius: 50% !important;
    width: 20px;
    height: 20px;
}

.bigger-checkboxes{
    height: 30px;
    width: 20px;
}

input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
}

input[type="radio"] {
    /* background-color only for content */
    background-color:$primary-background !important;
  }
  
  /* appearance for checked radiobutton */
  input[type="radio"]:checked {
    background-color: $active-blue !important;
    //background-image: linear-gradient(to bottom, #5294ce, #3176b3) !important;
    background: radial-gradient(circle, $active-blue 40%, $primary-background 49%, $primary-background 100%) !important;
    border: 1px solid #909090 !important;

  }

.users-basic-info-table {
  font-size: 15px;
  tbody {
    margin: 10px;
    .key-div {
      text-align: end;
      color: $dull-text-color;
      vertical-align: top !important;
    }
    .value-div {
      text-align: start;
      margin-inline-start: 10px;
    }
  }
}
table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      border-top: $table-row-border !important;
      border-bottom: $table-row-border !important;
    }
  }
  tbody {
    color: $text-color;
    td {
      border-top: $table-row-border !important;
    }
  }
}

.view-lists {
 font-size: $input-field-and-label-font-size !important;
  height: 24px !important;
  display: inline-flex !important;
  margin: 6px 3px !important;
  border-radius: 15px !important;
  min-width: 50px !important;
  padding: 0px !important;
  text-align: start;
  width: 98% !important;
  justify-content: start;
  padding-top: 1px !important;
  span {
    padding: 0px 8px !important;
    margin-inline-start: 0px !important;
    font-size: $input-field-and-label-font-size !important;
    border-radius: 15px !important;
    position: relative !important;
    top: 1px !important;
  }
}

.editIcon {
  margin-inline-start: 9px;
}


.lists-display-ul .show-tags-delete {
  visibility: hidden;
}

.lists-display-ul li:hover .show-tags-delete {
  visibility: visible;
}

.lists-display-ul{
  max-height: 200px;
  width: 100%;
}

.applyBorderOnScroll{
  border: $border-color;
  border-radius: 5px;
  overflow: auto;
  background:$primary-background;
}

.comm-input-field-style{
    background: $primary-background!important;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    height: $input-field-height;
}

.dropdown-item{
  padding:0px !important;
  width:13px !important;
}

.show-tags-delete {
  margin-inline-start: 7px;
  margin-inline-end: 5px;
  svg{
    fill:#939393 !important;
  }
  svg:hover{
    fill: #c5c0c0 !important;
  }
}

.search-bar-comm-style{
  height:30px;
  position:relative;
    margin-inline-start: 2%;
    margin-top: 5px;
  input{
    border:0px solid #303030;
    height: 25px;
    padding-inline-start: 3%;
  }
  svg{
    position: absolute;
    inset-inline-start:12px;
    top: 44%
  }
}

.btn {
  font-size: 14px !important;
  height: 100%;
}

.border {
  border: $border-color !important;
}

.custom-control-label::before {
  background-color: $primary-background;
}

.primary-btn-style {
  margin-top: 1%;
  display: flex;
  position: relative;
  inset-inline-start:21%;
  width: 20%;
  button {
    height: 35px;
    width: 70px;
    font-size:14px;
  }
}

.validationmessage {
  color: $danger-color;
  font-size: 11px;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block;
    width: 20px;
    height: 19px;
    margin-top: 0px;
    margin-inline-start: -1px;
    border: $border-color;
    border-radius: .25em;
    background: transparent;
}

input[type="checkbox"]:checked:after {
  content: "✔";
  color: $active-blue;
  position: absolute;
  font-size: 16px;
  line-height: 1;
  transition: all 0.2s;
  font-family: Helvetica, Arial, sans-serif;
  padding-inline-start: 4px;
  padding-top: 2px;
}

.breadcrumb{
  padding: .75rem 1rem !important;
  background: $primary-background !important;
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}

.secondary-btn-style:hover{
  text-decoration: underline;
}
.secondary-btn-style{
  color:$text-color;
}
.set-height-of-div{
  height: calc(100vh - 135px);
  overflow:auto;
}

.add-new-lists-styles{
  display: inline-flex;
  border-radius: 10px;
  margin: 0px 8px;
  justify-content: start;
  height: 27px;
  color:$add-button-text-color;
  padding: 4px 0px 0px 0px;
  svg{
    fill:$add-button-text-color !important;
  }
}

.add-new-lists-styles:hover{
  color:$add-button-text-color-hover;
  svg{
    fill:$add-button-text-color-hover !important;
  }
}
::v-deep{

  .multiselect__content-wrapper{
    display:none;
  }
  .multiselect__tag {
      background-color: $primary-background !important;
    }
    .multiselect__tags{
        background: $primary-background !important;
        border: $border-color !important;
    }
    .multiselect__option--highlight {
        background: $bg-color-on-hover !important;
    }
    .multiselect__content {
        background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__input:focus{
      outline:none;
      box-shadow: none;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color: $text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$text-color !important;
       font-size: 23px;
    }
    .multiselect *{
        font-size: $input-field-and-label-font-size !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect__placeholder {
      padding-top: 0px;
     }
    .multiselect{
      color:$text-color !important;
      font-size: $input-field-and-label-font-size !important;
      width:331px;
      min-height: 38px;
      height: 38px;
    }
    .multiselect__option--selected{
        background: $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
        border: 1px solid $bg-color-on-hover !important;
        position: relative;
        display: block;
        background: transparent;
        width: 100%;
        max-height: 240px;
        overflow: auto;
        border: $secondary-border-color;
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        z-index: 50;
        -webkit-overflow-scrolling: touch;  
    }

    .parent-field-dropdown{
      .multiselect__content-wrapper{
        bottom:0px !important;
      }  
    }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color !important;
    }
    .multiselect__tags {
        background: $primary-background!important;
        height: $input-field-height;
        min-height: 38px;
    }

    // .parent-fields-wrapper{
    //   .multiselect{
    //     min-height: 38px !important;
    //     height:auto !important;
    //     .multiselect__tags{
    //       height:auto !important;
    //       padding: 8px 40px 8px 8px !important;
    //     }
    //     .multiselect__placeholder{
    //       margin-bottom: 0px !important;
    //     }
    //   }  
    // }

}

.dull-text{
    color:$dull-text-color;
    font-size:12px;
}

.delete-user-icon{
  position: absolute;
  inset-inline-end: 17px;
  top: -2px;
  height: 23px;
  width: 23px;
  border: $border-color;
  background: $primary-background;
  border-radius: 30px;
  color: $text-color;
}

.add-user-icon-wrapper{
    height: 45px;
    width: 45px;
    margin: 0px auto;
    line-height: 54px;
    border-radius: 6px;
    background: $primary-background;
    color: $add-button-text-color;
    border: 1px solid $add-button-border-color; 
    svg{
      color: $add-button-text-color !important;
      margin: 0px auto;
      width: 100%;
      position: relative;
      top: -6px;
    }
}
.icons-with-text-wrapper{
    height: 45px;
    width: 45px;
    margin: 0px auto;
    line-height: 54px;
    border-radius: 6px;
    border: $border-color;
    svg{
      margin: 0px auto;
      width: 100%;
      position: relative;
      top: -6px;
    }
}

.add-user-icon-wrapper:hover{
    color: $add-button-text-color-hover;
    border: 1px solid $add-button-border-on-hover; 
}

.delete-user-icon{
  visibility: hidden;
}

.comm-tags-class:hover .delete-user-icon{
  visibility: visible;
}

.add-to-lang-dict-styles{
  color:$add-button-text-color;
  text-align: start;
  padding-inline-end: 17px;
  flex-direction: column;
  padding-top: 3px;
  svg{
    margin-inline-end: 2px;
    margin-bottom: 3px;
  }
}

.add-to-lang-dict-styles:hover{
  text-decoration: underline;
  color:$add-button-text-color-hover;
}

.ellipsis-to-entry{
  color: #9a9620;
  padding-inline-start: 4px;
}

.selected-tags-style{
  background: $tags-background-color;
  border: 1px solid $tags-border-color;
  border-radius: 15px;
  font-size: 12px !important;
  min-height: 30px !important;
  display: inline-flex !important;
  margin: 2px !important;
  border-radius: 15px !important;
  min-width: 50px !important;
  padding: 0px !important;
  text-align: center;
  width: auto !important;
  padding-inline-start: 12px !important;
  justify-content: center;
  padding-top: 4px !important;
  padding-inline-end: 4px !important;
  .remove-tag{
    line-height:18px;
  }
}
</style>